import MappingOrigin from "./mappingOrigin";
import ObjectModel from "../objectModel";
import {ModelType} from "~/enums/modelType";
import OriginWrapperObjectModel from "~/models/mapping/originWrapperObjectModel";
import MappingOriginOptionObjectModel from "~/models/mapping/mappingOriginOptionObjectModel";
import MappingOriginOptionObjectModelRelation from "~/models/mapping/mappingOriginOptionObjectModelRelation";
import OriginWrapperObjectModelRelation from "~/models/mapping/originWrapperObjectModelRelation";

export default class MappingOriginObjectModel extends MappingOrigin {
  readonly friendly_type = ModelType.ObjectModel;

  root_client_id: string;
  model_client_ids: string[];

  get rootIdentifier(): string {
    return this.root_client_id;
  }

  set rootIdentifier(value: string) {
    this.root_client_id = value;
  }

  get root(): OriginWrapperObjectModel {
    return new OriginWrapperObjectModel(ObjectModel.repo.find(this.root_client_id));
  }

  get relationshipModels() {
    return this.relation_identifiers.map(relationIdentifier => new OriginWrapperObjectModelRelation(relationIdentifier))
  }

  get modelIdentifiers() {
    return this.model_client_ids || [];
  }

  set modelIdentifiers(value) {
    this.model_client_ids = value;
  }

  static availableOptions(objectModel: ObjectModel, opts: { includeSelf: false }): MappingOriginOptionObjectModelRelation[]
  static availableOptions(objectModel: ObjectModel, opts?: { includeSelf: true }): (MappingOriginOptionObjectModel | MappingOriginOptionObjectModelRelation)[]
  static availableOptions(objectModel: ObjectModel, opts: { includeSelf?: boolean } = {}): (MappingOriginOptionObjectModel | MappingOriginOptionObjectModelRelation)[] {
    if (!(objectModel instanceof ObjectModel)) { return []; }
    // default includeSelf is true
    const includeSelf = opts.hasOwnProperty('includeSelf') ? opts.includeSelf : true
    let objectModelSources: MappingOriginOptionObjectModel[] = []
    if (includeSelf) {
      objectModelSources.push(
        new MappingOriginOptionObjectModel({origin: objectModel})
      );
    }
    let relationSources: MappingOriginOptionObjectModelRelation[] = [];

    (objectModel.objectModelRelationsArray || []).forEach(relation => {
        relation.related_object_models.forEach(model => {
          relationSources.push(new MappingOriginOptionObjectModelRelation({origin: relation, model: model, inverse_relation: false}))
      })
    })

    // handle inverse relations
    objectModel.inverseObjectModelRelationsArray.forEach(relation => {
      relationSources.push(new MappingOriginOptionObjectModelRelation({origin: relation, model: relation.rootObjectModel, inverse_relation: true}))
    })
    
    return [].concat(objectModelSources, relationSources)
  }

  get availableOptions(): (MappingOriginOptionObjectModel | MappingOriginOptionObjectModelRelation)[] {
    return MappingOriginObjectModel.availableOptions(this.root.object);
  }

  // ******************** NESTED MODEL MAPPING ******************** //
  /**
   * Object models in nested model mappings can potentially establish an additional relationship
   * to the main, top-level root model mapping object model
   */
  get canRelateToRoot(): boolean {
    return true
  }

  nestedToRootAvailableOptions(rootObject: ObjectModel): MappingOriginOptionObjectModelRelation[] {
    return MappingOriginObjectModel.availableOptions(rootObject, {includeSelf: false})
      .filter(option => {
        return this.root.object && option.model.id === this.root.object.id
      })
  }
  // ******************** NESTED MODEL MAPPING END ******************** //
}
